import { isComponentFor } from 'Shared/resolve-component';
export default (currentPage) => {
    return isComponentFor(currentPage.componentName, "Avensia.Shop.Features.MyMenigo.Pages.MyMenigoBasic.MyMenigoBasicPageViewModel");
};
export function componentNameIsMyMenigoPage(componentName) {
    return isComponentFor(componentName, "Avensia.Shop.Features.MyMenigo.Pages.MyMenigoBasic.MyMenigoBasicPageViewModel");
}
